import { useEffect, useState } from 'react';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getOwnedProducts } from 'self-service-api/api/getProducts';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';
import { getOwnedHubsAndSuiteApiNames } from 'ui-addon-upgrades/_core/utils/getOwnedHubsAndSuiteApiNames';
import { REQUEST_SEAT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { H5 } from 'foundations-components/transitional/components/H5';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ViewOnlyHeader = () => {
  const [ownedHubsAndSuiteApiNames, setOwnedHubsAndSuiteApiNames] = useState([]);
  useEffect(() => {
    getOwnedProducts().then(ownedProducts => {
      const parsedOwnedApiNames = getOwnedHubsAndSuiteApiNames(ownedProducts);
      setOwnedHubsAndSuiteApiNames(parsedOwnedApiNames);
    }).catch(error => {
      Raven.captureException(Error('Failed to fetch owned products'), {
        extra: {
          message: error.message
        }
      });
    });
  }, []);
  if (!ownedHubsAndSuiteApiNames.length) return null;

  // given no product context, default to the first owned hub or suite api name
  const upgradeApiName = ownedHubsAndSuiteApiNames[0];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      wrap: "wrap",
      gap: 20,
      children: [/*#__PURE__*/_jsxs(H5, {
        marginBlockEnd: "0",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.viewOnlyHeader.title"
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'userPreferences.viewOnlyHeader.tooltip'
          }),
          tooltipProps: {
            minInlineSize: '340px'
          },
          marginInlineStart: "200"
        })]
      }), /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        wrap: "wrap",
        gap: 20,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.viewOnlyHeader.message"
        }), /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
          upgradeData: {
            app: 'UserPreferencesUI',
            screen: 'users-preferences-profile',
            upgradeProduct: ApiNameToUpgradeProductMap[upgradeApiName],
            uniqueId: 'view-only-header',
            apiName: upgradeApiName
          },
          use: "tertiary",
          size: "sm",
          purchaseMotions: [REQUEST_SEAT],
          level: 1,
          showSeatSelector: true,
          canViewNewSeats: true,
          ownedHubsAndSuiteApiNames: ownedHubsAndSuiteApiNames
        })]
      })]
    }), /*#__PURE__*/_jsx(HR, {
      marginBlockStart: "400"
    })]
  });
};